import * as React from 'react';
import { SVGProps } from 'react';

const IconGeoSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 9.91C19 15.09 12 22 12 22S5 15.09 5 9.91C5 5.933 8.134 3 12 3s7 2.934 7 6.91zM12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
    />
  </svg>
);
export default IconGeoSizeM;
